import React from "react";
import { Table, Button, Tooltip } from "antd";
import { SettingOutlined } from "@ant-design/icons";

export default function IGGTable({ data, onEdit }) {
  const columns = [
    {
      title: "IGG Name",
      dataIndex: "igg_name",
      key: "igg_name",
      align: "center",
    },
    {
      title: "IGG Maker",
      dataIndex: "igg_maker",
      key: "igg_maker",
      align: "center",
    },
    {
      title: "IGG Model",
      dataIndex: "igg_model",
      key: "igg_model",
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Tooltip title="Configure parameters">
          <Button
            type="primary"
            size="small"
            onClick={() => onEdit?.(record)}
            style={{ marginRight: "5px" }}
            icon={<SettingOutlined />}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      bordered
      pagination={{ pageSize: 10 }}
      rowKey="key"
      className="custom-table"
    />
  );
}
